import React, { useEffect, useState, useContext } from "react";
import {
  getUsers,
  getRoles,
  deleteUser,
  apiClient,
  Updatepassword,
} from "../../../Utility/Api";
import { toast } from "react-toastify";
import "../../../Utility/pagination.css";
import { AddUser, EditUser } from "./form";
import { Deletemodel, Pagination } from "../../Common/Functions";
import { WarehouseContext } from "../../../Utility/UserContext";
import { useLocation, useNavigate } from "react-router-dom";
import { isReadonlyRoute, NaviGate } from "../../../Utility/function";

const User_list = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const readonly = isReadonlyRoute(pathname);
  const [users, setUsers] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [deleteID, setdeleteID] = useState("");
  const [deletemodel, showDeletemodel] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState(null);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const rolesPerPage = 10;
  const { showLoader, hideLoader, shopItem } = useContext(WarehouseContext);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [matchError, setMatchError] = useState("");
  const [showModal1, setShowModal1] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async (page = 1, text = "") => {
    showLoader();
    try {
      // const response = await getUsers(page, text, "");
      const response = await getUsers(page, text, shopItem?.shop_id);
      if (response.data && response.data.data) {
        setUsers(response.data.data);
        setTotalPages(response.data.pagination.total_pages);
        hideLoader();
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      toast.error("Failed to fetch user data");
      hideLoader();
    }
  };

  const openAddModal = () => {
    setShowAddModal(!showAddModal);
  };

  const openEditModal = (user) => {
    setSelectedUsers(user);
    setShowEditModal(!showEditModal);
  };

  const handledeletemodel = (Id) => {
    showDeletemodel(true);
    setdeleteID(Id);
  };

  const handleDelete = async () => {
    try {
      await deleteUser(deleteID);
      toast.success("User deleted successfully");
      fetchUsers(currentPage);
      showDeletemodel(false);
    } catch (error) {
      console.error("Error deleting user:", error);
      toast.error("Error deleting user");
    }
  };

  const handleDocument = (userId) => {
    navigate("/UserDocument", { state: { userId } });
  };

  const HandleSalaryModule = (user) => {
    navigate(`/Salary`, { state: { salary: user } });
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
    fetchUsers(pageNumber);
  };

  const handleSearch = async (text) => {
    fetchUsers(1, text);
    setCurrentPage(1);

  };

  const validatePassword = (password) => {
    const regex =
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/;
    return regex.test(password);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    if (!validatePassword(e.target.value)) {
      setPasswordError(
        "Password must be at least 6 characters long and include letters, numbers, and special characters."
      );
    } else {
      setPasswordError("");
    }
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
    if (password !== e.target.value) {
      setMatchError("Passwords do not match.");
    } else {
      setMatchError("");
    }
  };

  const handleClear = () => {
    setPassword("");
    setConfirmPassword("");
    setPasswordError("");
    setMatchError("");
    setShowModal1(false);
  };

  const openPasswordModal = (userId) => {
    setSelectedUserId(userId);
    setShowModal1(true);
  };

  const handleSubmit1 = async () => {
    if (passwordError || matchError || !password || !confirmPassword) {
      toast.error("Please fix errors before submitting.");
      return;
    }
    try {
      var payload = {
        employee_id: selectedUserId,
        new_password: password,
      };
      await Updatepassword(payload);
      toast.success("Password updated successfully.");
      setShowModal1(false);
      handleClear();
    } catch (error) {
      toast.error("Error updating password.");
    }
  };

  return (
    <div className="page-wrappers">
      <div className="page-content">
        <NaviGate />
        <div className="mb-0 d-flex justify-content-between align-items-center">
          <h6 className="mb-0 text-uppercase">User List</h6>
          {!readonly && (
          <button
            type="button"
            onClick={openAddModal}
            className="btn btn-primary mb-0 text-normal rounded-1"
          >
            Add User
          </button> )}
        </div>
        <hr />

        <div className="card">
          <div className="card-body">
            <div className="col-12 col-md-6 col-lg-4 mb-3 mb-md-2">
              <div
                className="d-flex position-relative"
                style={{ width: "100%" }}
              >
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Search..."
                  onChange={(e) => handleSearch(e.target.value)}
                />
                <img
                  src="/assets/images/icons/search.png"
                  alt="Search Icon"
                  style={{
                    position: "absolute",
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    height: "18px",
                    pointerEvents: "none",
                  }}
                />
              </div>
            </div>
            <div className="table-responsive">
              <table
                id="example"
                className="table table-sm table-striped table-bordered"
                style={{ width: "100%", fontFamily: "poppins" }}
              >
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>ID Card</th>
                    <th>Image</th>
                    <th>Status</th>
                    <th>Role</th>
                    {!readonly && (<> <th>Actions</th>
                    <th>Password Update</th> </> )}
                  </tr>
                </thead>
                <tbody>
                  {users?.map((user, index) => (
                    <tr key={user.user_Id}>
                      <td>{(currentPage - 1) * rolesPerPage + index + 1}</td>
                      <td>{user.full_name}</td>
                      <td>{user.email || 'N/A'}</td>
                      <td>{user.phone || 'N/A'}</td>
                      <td>{user.id_card_no}</td>
                      <td>
                        <img
                          src={
                            user.image
                              ? `${apiClient.defaults.baseURL}/media/${user.image}`
                              : "./../assets/images/profile.png"
                          }
                          alt="User Profile"
                          height="35"
                          width="35"
                          style={{ objectFit: "cover" }}
                        />
                      </td>
                      <td>{user.status === "1" ? "Active" : "Inactive"}</td>
                      <td>{user.role_title}</td>
                     {!readonly && ( <> <td>
                        {user.email != "admin@gmail.com" && (
                          <div>
                            <img
                              src="/assets/images/icons/edit.png"
                              onClick={() => openEditModal(user)}
                              height={"20px"}
                              alt=""
                            />
                            <img
                              src="/assets/images/icons/delete.png"
                              className="mx-1"
                              onClick={() => handledeletemodel(user.user_Id)}
                              height={"20px"}
                              alt=""
                            />
                            <img
                              src="/assets/images/icons/doc.png"
                              className="mx-1"
                              onClick={() => handleDocument(user)}
                              height={"20px"}
                              alt=""
                            />
                            <img
                              src="/assets/images/icons/wallet.png"
                              className="mx-1"
                              onClick={() => HandleSalaryModule(user)}
                              height={"20px"}
                              alt=""
                            />
                            {/* <button
                              className="btn btn-sm p-0 border-0"
                              onClick={() => handleDocument(user)}
                            >
                              <i
                                className="fas fa-file-alt text-primary"
                                height={"8px"}
                              ></i>
                            </button> */}

                            {/* <button
                              className="btn btn-sm p-0 border-0"
                              onClick={() => HandleSalaryModule(user)}
                            >
                              <i
                                className="fas fa-dollar-sign  text-success "
                                height={"8px"}
                                width={"8px"}
                              ></i>
                            </button> */}
                          </div>
                        )}
                      </td>
                      <td>
                        {user.email != "admin@gmail.com" && (
                          <button
                            className="btn btn-sm p-0 border-0"
                            onClick={() => openPasswordModal(user.user_Id)}
                          >
                            <i
                              className="fa-duotone fa-solid fa-lock fa-2xs text"
                              height={"8px"}
                              width={"8px"}
                            ></i>
                          </button>
                        )}
                      </td>
                      </>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>

              {showModal1 && (
                <div className="modal fade show" style={{ display: "block" }}>
                  <div className="modal-dialog">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Reset Password</h5>
                        <button
                          type="button"
                          className="btn-close"
                          aria-label="close"
                          onClick={() => handleClear()}
                        ></button>
                      </div>
                      <div className="modal-body">
                        <div className="form-group">
                          <h6 className="modal-title text-medium">New Password</h6>

                          <input
                            type="password"
                            className="form-control mb-2"
                            placeholder="New Password"
                            value={password}
                            onChange={handlePasswordChange}
                          />
                          {passwordError && (
                            <div className="text-danger  text-small w-100 text-wrap text-start">
                              {passwordError}
                            </div>
                          )}
                        </div>

                        <div className="form-group">
                          <h6 className="modal-title text-medium">Confirm Password</h6>

                          <input
                            type="password"
                            className="form-control mb-2"
                            placeholder="Confirm Password"
                            value={confirmPassword}
                            onChange={handleConfirmPasswordChange}
                          />
                          {matchError && (
                            <div className="text-danger text-small w-100 text-wrap text-start">
                              {matchError}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          className="btn btn-success"
                          onClick={handleSubmit1}
                          disabled={passwordError || matchError || !password || !confirmPassword}

                        >
                          Update Password
                        </button>
                        <button
                          className="btn btn-secondary"
                          onClick={() => handleClear()}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </div>

      {deletemodel && (
        <Deletemodel
          setShowModal={showDeletemodel}
          handleDelete={handleDelete}
        />
      )}

      <AddUser
        showModal={showAddModal}
        setShowModal={openAddModal}
        fetchUser={() => fetchUsers(currentPage)}
      />

      <EditUser
        showModal={showEditModal}
        setShowModal={openEditModal}
        fetchUser={() => fetchUsers(currentPage)}
        selectedUser={selectedUsers}
      />
    </div>
  );
};

export default User_list;
